module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_dre.ff9a0f33.png";